import CalculatorSupplyListResult from "../utils/CalculatorSupplyListResult";

export default CalculatorSupplyListResult;
